import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

const CloseIcon = (props: Props) => {
    const { color = 'white', width = 19, height = 19, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <rect
                x="1.57227"
                width="24.4444"
                height="2.22222"
                transform="rotate(45 1.57227 0)"
                fill={color}
            />

            <rect
                x="18.8574"
                y="1.57129"
                width="24.4444"
                height="2.22222"
                transform="rotate(135 18.8574 1.57129)"
                fill={color}
            />
        </svg>
    );
};

export default CloseIcon;